import { LayoutDashboard, Plane, Receipt, CreditCard, Settings, ShieldQuestion, Repeat, BarChart3, Tags } from 'lucide-react';
import { ROUTES } from '@/routes';

/** Main navigation, shared by the desktop sidebar and the mobile menu. */
export const NAV_ITEMS = [
  { to: ROUTES.app.dashboard, icon: LayoutDashboard, label: 'Dashboard' },
  { to: ROUTES.app.insights, icon: BarChart3, label: 'Insights' },
  { to: ROUTES.app.transactions, icon: Receipt, label: 'Expenses' },
  { to: ROUTES.app.subscriptions, icon: Repeat, label: 'Subscriptions' },
  { to: ROUTES.app.tags, icon: Tags, label: 'Tags' },
  { to: ROUTES.app.trips, icon: Plane, label: 'Trips' },
  { to: ROUTES.app.reviews, icon: ShieldQuestion, label: 'Review Queue' },
  { to: ROUTES.app.accounts, icon: CreditCard, label: 'Accounts' },
  { to: ROUTES.app.settings, icon: Settings, label: 'Settings' },
];
